/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Integrations_DescriptionInputs */

const en_settings_integrations_description = /** @type {(inputs: Settings_Integrations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect external services to import documents.`)
};

const es_settings_integrations_description = /** @type {(inputs: Settings_Integrations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecta servicios externos para importar documentos.`)
};

/**
* | output |
* | --- |
* | "Connect external services to import documents." |
*
* @param {Settings_Integrations_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_integrations_description = /** @type {((inputs?: Settings_Integrations_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Integrations_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_integrations_description(inputs)
	return en_settings_integrations_description(inputs)
});